import React, { useState, useEffect } from 'react';
import Slider from 'react-slick';
import NextArrow from '../NextArrow/NextArrow';
import PrevArrow from '../PrevArrow/PrevArrow';
import './styles.css';

function Clients() {
	const settings = {
		dots: false,
		infinite: true,
		speed: 500,
		nextArrow: <NextArrow />,
		prevArrow: <PrevArrow />,
		slidesToShow: 4,
		slidesToScroll: 4,
		initialSlide: 0,
		responsive: [
			{
				breakpoint: 1024,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 3,
					infinite: true
				}
			},
			{
				breakpoint: 600,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
					initialSlide: 1
				}
			}
		]
	};

	// Importando imagens dinamicamente
	const [logos, setLogos] = useState([]);

	useEffect(() => {
		// Função para importar todas as imagens de uma pasta
		const importAllImages = async () => {
			const imageContext = require.context('../../assets/clientes', false, /\.(png|jpe?g|svg)$/);
			const images = imageContext.keys().map(path => {
				const module = imageContext(path);
				return module.default || module;
			});
			setLogos(images);
		};

		importAllImages();
	}, []);

	return (
		<div className="partnersResponsive">
			<h2>Clientes</h2>
			<Slider {...settings}>
				{logos.map((logo, index) => (
					<div key={index}>
						<img src={logo} className='partnerLogo' alt={`Logo do cliente ${index + 1}`} />
					</div>
				))}
			</Slider>
		</div>
	);
}

export default Clients;